module.exports = __webpack_public_path__ + "static/media/Daniel Webster - 1836.7f5de3b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Daniel Webster - 1836.jpg
// module id = 452
// module chunks = 0